import React from "react";
import './eventcal.css';

function Calendar() {
    return (
        <div id="events-call">
            <h1>Events and Calendar</h1>
            <div className="cs-container">
                <div className="cs-events">
                    {/* Google Calendar Embed */}
                    <iframe 
                        src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FChicago&showPrint=0&showTitle=0&src=Mjg5ZWFiYmI0M2I2MTFlZjA4NTE1MDBmMGNkOTAzYjljMmVmZjBlYzJlYzc1MTdjZDU4OTMwMmU2MGFkYzhjM0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%238e24aa" 
                        style={{border: 0}} 
                        width="100%" 
                        height="800" 
                        frameBorder="0" 
                        scrolling="no"
                        title="Sri Sathya Sai Center Milwaukee Events Calendar"
                    ></iframe>
                </div>
            </div>
        </div>
    );
}


export default Calendar